import React from 'react';
import clsx from 'clsx';

import PriceDisplay from '../PriceDisplay';
import FeatureItem from '../FeatureItem';
import PriceDisplayDiscount from '../PriceDisplayDiscount';

import {useTranslation} from 'react-i18next';

import {PackageWithPromotion} from '../../state-management/app';
import {getActualMoney} from '../../utils';

import styles from './PackageItem.module.css';

interface PackageItemProps {
  className?: string
  recommended?: boolean
  pack: PackageWithPromotion //package is a reserve name, so use pack
  selected: boolean
  priceReduceReasons: PriceReducedReason[]
  isGreyOut?: boolean

  onClick(pack: PackageWithPromotion): void
}

export interface PriceReducedReason {
  isDiscounted: boolean
  reason: string
  reducedAmount: number,
  text: string
}

const PackageItem = (
  {
    selected,
    recommended,
    pack,
    priceReduceReasons,
    isGreyOut,
    onClick
  }: PackageItemProps) => {

  const {t} = useTranslation();

  const rootClassNames = clsx(styles.root, selected && styles.packageSelected, isGreyOut && styles.greyOut);

  return (
    <div
      className={rootClassNames}
      onClick={() => onClick(pack)}
      data-manabie="PackageItem-root"
    >
      <div
        className={clsx(selected && styles.counterSelected, recommended && styles.recommendedCorner)}
        data-manabie="PackageItem-container"
      >
        {
          recommended && <>
            <div className={styles.cornerStar} data-manabie="PackageItem-corner">
              <svg width="24" height="26" viewBox="0 0 24 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M11.9996 18.9515L16.1506 21.5868C16.9079 22.0676 17.8421 21.3534 17.6411 20.4473L16.5396 15.4802L20.2082 12.1372C20.8768 11.528 20.5194 10.3727 19.6379 10.2941L14.8096 9.86317L12.9203 5.17425C12.5757 4.31903 11.4234 4.31903 11.0788 5.17425L9.18956 9.86317L4.36119 10.2941C3.47976 10.3727 3.12236 11.528 3.79095 12.1372L7.45956 15.4802L6.35797 20.4473C6.15701 21.3534 7.09124 22.0676 7.84856 21.5868L11.9996 18.9515Z"
                  fill="#F2C94C"
                />
              </svg>
            </div>
            <div className={styles.recommended}>{t('recommended')}</div>
          </>
        }
        <div className={styles.packageName}>{pack.name}</div>
        {/*<span className="text is-title-small">*/}
        {/*  {`${t('servicePeriod')} - ${getDateProperty(pack.period.seconds)}`}*/}
        {/*</span>*/}
        <PriceDisplay
          price={pack.price}
          finalPrice={getActualMoney(pack)}
          isDiscounted={!!pack.carriedOverAmount || !!pack.isPromotionApplied}
        />
        {
          priceReduceReasons.map((reason, index) => {
            if (!reason.isDiscounted) return null;

            return (
              <PriceDisplayDiscount
                key={index}
                s={reason.text}
                num={reason.reducedAmount}
                reducedName={reason.reason}
              />
            )
          })
        }
        <hr className={styles.divider}/>
        <div className={styles.feature}>
          {
            pack.descriptionList.map((desc, index) => {
              return (
                <FeatureItem key={index} content={desc}/>
              )
            })
          }
        </div>
      </div>
    </div>
  );
};

export default PackageItem;
